import * as React from 'react';

export const useTransitionEnded = (isExpanded: boolean) => {
  const [contentHasTransitioned, setContentHasTransitioned] = React.useState<boolean>(false);

  React.useEffect(() => {
    if (!isExpanded) { setContentHasTransitioned(false); }
  });

  const transitionEndListener = (node: HTMLElement) => {
    node.addEventListener('transitionend', () => setContentHasTransitioned(true), false);
  };

  return {
    contentHasTransitioned, setContentHasTransitioned, transitionEndListener
  };
};
